module.exports = __webpack_public_path__ + "img/map-option-total.d3af2262.png";